import {
    Typography,
    Box,
    ThemeProvider,
    createTheme,
    responsiveFontSizes,
} from '@mui/material'
import { t } from 'i18next'
import { useMemo, useRef } from 'react'
import { LineDetail } from './LineDetail'
import OrderSummary from './OrderSummary'
import { IOrderInfoDisplayProps } from './interface'
import { newThemeV5 } from 'utilities/themeConfig'
import { TopSection } from './TopSection'
import useResizeObserver from 'views/CustomerFacingDisplay/utils/useResizeObserver'

const defaultTheme = newThemeV5('light')
const OrderInfoDisplay = (props: IOrderInfoDisplayProps) => {
    const refOrderInfo = useRef<any>(undefined)
    const {
        variant,
        showAssignTo,
        orderItems = [],
        subOrders = [],
        ...order
    } = props
    const isEmptyOrder = (orderItems?.length ?? 0) === 0
    const isSingleOrder = !showAssignTo
    const orderDetailSize = useResizeObserver(refOrderInfo)

    const themes = useMemo(
        () =>
            responsiveFontSizes(
                createTheme({
                    ...defaultTheme,
                    components: {
                        ...defaultTheme.components,
                        MuiTypography: {
                            ...defaultTheme.components?.MuiTypography,
                            defaultProps: {
                                variant: 'inherit',
                                color: 'inherit',
                            },
                        },
                    },
                }),
            ),
        [],
    )

    return (
        <ThemeProvider theme={themes}>
            <Box position={'relative'} height={'100%'}>
                <Typography
                    component={'span'}
                    height={'100%'}
                    variant={variant}
                >
                    <Box
                        style={{
                            height: `calc(85svh - ${orderDetailSize.height}px)`,
                        }}
                        sx={(x) => {
                            return {
                                pt: 2,
                                borderTop:
                                    '2px solid  ' +
                                    x.palette.background.default,

                                overflowY: 'scroll',
                            }
                        }}
                    >
                        {isEmptyOrder && (
                            <Box p={3}>
                                <Typography>
                                    {t('table_sale_lookup.label.no_order_line')}
                                </Typography>
                            </Box>
                        )}
                        {orderItems &&
                            orderItems.map((o, i) => {
                                return (
                                    <LineDetail
                                        key={`cfd-order-line-${i}`}
                                        {...o}
                                        showAssignTo={showAssignTo}
                                    />
                                )
                            })}
                        <Box
                            ref={refOrderInfo}
                            position={'absolute'}
                            left={5}
                            right={0}
                            bottom={5}
                            maxHeight={400}
                            overflow={'auto'}
                        >
                            {isSingleOrder ? (
                                <OrderSummary {...order} />
                            ) : (
                                subOrders?.map((o, i) => {
                                    return (
                                        <Box pt={2} key={`sub-order-${i}`}>
                                            <TopSection
                                                orderName={o?.orderName}
                                                customerName={o?.customerName}
                                                tableName={''}
                                            />
                                            <OrderSummary {...o} />
                                        </Box>
                                    )
                                })
                            )}
                        </Box>
                    </Box>
                </Typography>
            </Box>
        </ThemeProvider>
    )
}

export default OrderInfoDisplay
